var FitToScrollerSupport        = require("enyo-ui/FitToScrollerSupport"),
    PageBackgroundSupport       = require("app/ui/PageBackgroundSupport"),
    Scroller                    = require("enyo-ui/Scroller"),
    ScrollerDecoratorScrollbars = require("app/ui/ScrollerDecoratorScrollbars"),
    ImageOptimizerSupport       = require("app/ui/ImageOptimizerSupport"),
    kind                        = require("enyo/kind");

require("./SimplePageView.less");
require("app/theme/ScrollerDecoratorScrollbars--page.less");

module.exports = kind(/** @lends  app.AppLayout.SimplePageView.prototype */ {

    /**
     * @private
     */
    name: "app.AppLayout.SimplePageView",

    /**
     * @private
     */
    mixins: [
        ImageOptimizerSupport,
        PageBackgroundSupport
    ],

    /**
     * @private
     */
    classes: "app-app-layout-simple-page-view",

    /**
     * @public
     */
    fit: true,

    /**
     * @public
     */
    centerContent: true,

    /**
     * @private
     */
    scrollerComponents: [{
        name:               "scrollerDecorator",
        kind:               ScrollerDecoratorScrollbars,
        classes:            "app-app-layout-simple-page-view__scroller-decorator",
        scrollerPath:       ".owner.$.scroller",
        theme:              "page",
        fadeChromeOnScroll: true,
        components:         [{
            name:           "scroller",
            kind:           Scroller,
            classes:        "app-app-layout-simple-page-view__scroller",
            fit:            true,
            vertical:       true,
            horizontal:     false,
            scrollChaining: false,
            components:     [{
                name:         "client",
                mixins:       [FitToScrollerSupport],
                classes:      "app-app-layout-simple-page-view__client",
                fit:          true,
                scrollerPath: ".owner.$.scroller"
            }]
        }]
    }],

    /**
     * @method
     * @private
     */
    initComponents: kind.inherit(function(sup) {
        return function() {
            this.createScroller();
            sup.apply(this, arguments);
        };
    }),

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.fitChanged();
            this.centerContentChanged();
        };
    }),

    /**
     * @protected
     */
    createScroller: function() {
        var scrollerComponents = this.scrollerComponents;

        this.createComponents(scrollerComponents);
        this.controlParent = this.$.client;
    },

    /**
     * @private
     */
    fitChanged: function() {
        var scrollerDecorator = this.$.scrollerDecorator,
            scroller          = this.$.scroller;

        if (this.fit) {
            !this.hasClass("enyo-fit") && this.addClass("enyo-fit");
            !scrollerDecorator.hasClass("enyo-fit") && scrollerDecorator.addClass("enyo-fit");
            scroller.set("fit", true);
        }
        else {
            while (this.hasClass("enyo-fit")) {
                this.removeClass("enyo-fit");
            }

            while (scrollerDecorator.hasClass("enyo-fit")) {
                scrollerDecorator.removeClass("enyo-fit");
            }
            scroller.set("fit", false);
        }
    },

    /**
     * @private
     */
    centerContentChanged: function() {
        var client = this.$.client;

        if (this.centerContent) {
            !client.hasClass("center-content") && client.addClass("center-content");
        }
        else {
            while (client.hasClass("center-content")) {
                client.removeClass("center-content");
            }
        }
    }

});
